export class DataCatalogIcebergRestProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "uri",
            "baseName": "uri",
            "type": "string",
            "format": ""
        },
        {
            "name": "warehouse",
            "baseName": "warehouse",
            "type": "string",
            "format": ""
        },
        {
            "name": "authType",
            "baseName": "authType",
            "type": "IcebergRestCatalogAuthType",
            "format": ""
        },
        {
            "name": "credentialsSecret",
            "baseName": "credentialsSecret",
            "type": "SchemaRegistryAuthConfigCredentialsSecret",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogIcebergRestProperties.attributeTypeMap;
    }
    constructor() {
    }
}
